import { render, staticRenderFns } from "./AutocompleteDrug.vue?vue&type=template&id=2bc31eca&"
import script from "./AutocompleteDrug.vue?vue&type=script&lang=js&"
export * from "./AutocompleteDrug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports